"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    filterChipVariants: ()=>filterChipVariants
});
const index_cjs_namespaceObject = require("../../variants/index.cjs");
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const filterChipVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: index_cjs_namespaceObject.filterChipSlots,
    variants: {
        type: index_cjs_namespaceObject.filterChipTypeVariants,
        disabled: index_cjs_namespaceObject.chipDisabledVariants,
        elevated: index_cjs_namespaceObject.chipElevatedVariants,
        emphasis: index_cjs_namespaceObject.chipEmphasisVariants,
        hasHelperText: {
            true: {},
            false: {}
        },
        hasIconLeft: {
            true: {
                checkIconSlot: 'absolute'
            }
        },
        selectedState: {
            true: {
                checkIconSlot: 'duration-medium',
                iconLeftSlot: 'duration-medium scale-0 opacity-0',
                faviconSlot: 'duration-medium w-0 scale-0 opacity-0'
            },
            false: {
                checkIconSlot: 'duration-short !w-[0] scale-0 opacity-0',
                iconLeftSlot: 'duration-short',
                faviconSlot: 'duration-short'
            }
        },
        hasCount: {
            true: {
                countSlot: 'duration-medium scale-100 pr-1 opacity-100 transition-all'
            },
            false: {
                countSlot: 'duration-short scale-0 pr-0 opacity-0 transition-all'
            }
        },
        showCheckIcon: {
            true: {},
            false: {}
        }
    },
    compoundVariants: index_cjs_namespaceObject.chipCompoundVariants,
    defaultVariants: index_cjs_namespaceObject.filterChipDefaultVariants
});
exports.filterChipVariants = __webpack_exports__.filterChipVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "filterChipVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
